import { useCallback, useEffect, useState } from "react";
import Logo from "@/assets/svg/capital/logo.svg";
import ArrowRight from "@/assets/svg/capital/arrow-right.svg";
import { Link } from "react-router-dom";
import GoToTopWrap from "@/views/HomePage/components/GoToTopWrap/index";
import { useStateStore } from "@/store";
import program1 from "@/assets/img/program-1.jpg";
import program2 from "@/assets/img/program-2.jpg";
import program3 from "@/assets/img/program-3.jpg";
import program4 from "@/assets/img/program-4.jpg";
import pcImg from "@/assets/img/pc-bg.png";
import phoneImg from "@/assets/img/phone-bg.png";
import "./index.scss";

const Capital = () => {
  const [num, setNum] = useState(0);
  const state = useStateStore();
  const { appType } = state.default;
  const [timer, setTimer] = useState();

  useEffect(() => {
    if (num >= 100) {
      clearInterval(timer);
      return;
    }
    // eslint-disable-next-line no-use-before-define, react-hooks/exhaustive-deps
  }, [num, timer]);
  useEffect(() => {
    return () => {
      clearInterval(timer);
    };
  }, [timer]);
  const add = useCallback(() => {
    setNum((prev) => prev + 1);
  }, []);

  const arr = [
    {
      date: "October 4",
      day: "Wednesday",
      url: program1,
      desc: "Arrival   |  Meet & Greet   |  VIP Dinner",
      id: 1,
    },
    {
      date: "October 5",
      day: "Thursday",
      url: program2,
      desc: "Program (TBD)   |   VIP Dinner   |   Private Concert",
      id: 2,
    },
    {
      date: "October 6",
      day: "Friday",
      url: program3,
      desc: "Boat Trip   |   Hiking  |   Mountain Top VIP Dinner",
      id: 3,
    },
    {
      date: "October 7-8",
      day: "Saturday & Sunday",
      url: program4,
      desc: "Your time to discover Switzerland on your own",
      id: 4,
    },
  ];
  return (
    <div className="capital-wrap">
      <div className="capital-header">
        <div className="capital-header-head">
          <img className="capital-header-head-logo" src={Logo} alt="" />
          <Link to="/" className="capital-header-head-link">
            <img src={ArrowRight} alt="" />
            Back to Homepage
          </Link>
        </div>
        <div className="capital-header-middle">Swiss Blockchain Capital Day</div>
        <div className="capital-header-bottom">October 4-6, 2023 | Zürich, Switzerland</div>
      </div>
      <div className="capital-number-info">
        {appType !== "phone" && (
          <img
            src={pcImg}
            alt=""
            onLoad={() => {
              setTimer(setInterval(() => add(), 10));
            }}
          />
        )}
        {appType === "phone" && (
          <img
            src={phoneImg}
            alt=""
            onLoad={() => {
              setTimer(setInterval(() => add(), 10));
            }}
          />
        )}
        <div className="capital-number-info-desc">Exclusive & private event</div>
        <div className="capital-number-info-bottom">
          <div className="capital-number-info-desc-number">{num}+</div>
          <div className="capital-number-info-desc-desc">
            Global VCs meet Swiss Funds of Funds & Family Offices
          </div>
        </div>
      </div>
      <div className="capital-program">
        <div className="capital-program-desc">
          An exclusive gathering of the most influential players in the blockchain industry, Swiss
          Blockchain Capital Day offers our guests a unique opportunity to come together, share
          ideas, and anticipate market trends. Our focus is on building deep, long-lasting
          connections. Join us to access premier industry resources. We look forward to welcoming
          you in Zürich!
        </div>

        {appType !== "phone" && (
          <div className="capital-program-bottom">
            <div className="capital-program-bottom-left">
              <div className="infoText">Program</div>
            </div>
            <ul className="capital-program-bottom-right">
              {arr.map((m) => {
                return (
                  <li key={m.id} className="capital-program-bottom-right-li">
                    <div className="capital-program-bottom-right-li-left">
                      <div className="capital-date">{m.date}</div>
                      <div className="capital-day">{m.day}</div>
                    </div>
                    <img className="capital-program-bottom-right-li-middle" src={m.url} alt="" />
                    <div className="capital-program-bottom-right-li-right">{m.desc}</div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        {appType === "phone" && (
          <div className="capital-program-bottom-phone">
            <div className="capital-program-bottom-phone-title">Program</div>
            <ul className="capital-program-bottom-phone-box">
              {arr.map((item) => {
                return (
                  <li key={item.id} className="capital-phone-box-li">
                    <div
                      className="capital-phone-box-li-top"
                      style={{
                        backgroundImage: `url('${item.url}')`,
                      }}
                    >
                      <div className="capital-phone-box-li-top-date">{item.date}</div>
                      <div className="capital-phone-box-li-top-day">{item.day}</div>
                    </div>
                    <div
                      className={
                        item.id === 3
                          ? "capital-phone-box-li-bottom special-pd"
                          : "capital-phone-box-li-bottom"
                      }
                    >
                      {item.desc}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
      <div className="capital-bottom">
        <div className="capital-bottom-title">Join Swiss Blockchain Capital Day</div>
        <div className="capital-bottom-box">
          <div className="capital-bottom-box-left">
            <div className="capital-bottom-box-left-btn">Get a ticket</div>
            <div className="capital-bottom-box-left-svg">
              <img
                src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1691652540805_arrow.svg"
                alt=""
              />
            </div>
          </div>
          <Link to="/sponsor" className="capital-bottom-box-right">
            <div className="capital-bottom-box-right-btn">Become a sponsor</div>
            <div className="capital-bottom-box-right-svg">
              <img
                src="https://yumi-frontend-assets.s3.ap-east-1.amazonaws.com/yumi/unity/1691652540810_arrow (1).svg"
                alt=""
              />
            </div>
          </Link>
        </div>
      </div>
      <GoToTopWrap custName={{ marginTop: 0 }} />
    </div>
  );
};

export default Capital;
